/**
 * Panel „Klienci” (prosty CRM, decyzje właściciela 2026-10-09): paleta kolorów etapów i podpowiedzi
 * „co dalej”. Same etapy (nazwy, kolejność, kolor, podpowiedź) ustawia firma i trzyma backend
 * (`accounts.UstawieniaKlientow`, startowe `DOMYSLNE_ETAPY`).
 *
 * ═══ PALETA ═══
 * Klucze muszą zgadzać się z `KOLORY_ETAPOW` w `accounts/api.py`. Klasy wpisane w całości,
 * bo Tailwind wycina klasy składane z kawałków.
 *
 * ═══ KROKI ═══
 * Podpowiedź przypięta do etapu: tytuł, jedno zdanie i akcje, które karta klienta zamienia
 * na przyciski i linki (`components/klienci/NastepnyKrok.jsx`):
 * - `dobierz`: asystent doboru w trybie klienta (zestaw od razu podpięty) i obok „Dobierz sprzęt ręcznie”
 *   (szybki dobór z katalogu w kafelku „Zestaw”, 2026-10-11);
 * - `ceny`: lista sprzętu z przełącznikami „Zamówiony”/„Dojechał” i linki do stron modeli (aktualne ceny);
 * - `lista`: ta sama lista sprzętu, bez linków (sprawdzenie dostawy);
 * - `osd`: narzędzie zgłoszeń do operatora z danymi klienta;
 * - `teczka`: teczka PME2 klienta (otwarcie albo założenie);
 * - `notatka`: pole nowej notatki.
 * Klucze muszą zgadzać się z `KROKI_ETAPOW` w `accounts/api.py`.
 */

// Kanban (2026-10-11): kolumna ma nagłówek w pełnym kolorze etapu (`naglowek`, jasne kolory z ciemnym tekstem),
// licznik na nim (`licznik`), jasne tło (`tlo`), ramkę przy przeciąganiu (`ramka`) i inicjały na karcie (`inicjaly`).
export const PALETA = {
  gray: { kropka: 'bg-gray-400', tlo: 'bg-gray-100/70', naglowek: 'bg-gray-500 text-white', licznik: 'bg-white/25', ramka: 'ring-gray-400', inicjaly: 'bg-gray-100 text-gray-600', nazwa: 'szary' },
  sky: { kropka: 'bg-sky-500', tlo: 'bg-sky-50', naglowek: 'bg-sky-600 text-white', licznik: 'bg-white/25', ramka: 'ring-sky-400', inicjaly: 'bg-sky-100 text-sky-800', nazwa: 'błękitny' },
  blue: { kropka: 'bg-blue-600', tlo: 'bg-blue-50', naglowek: 'bg-blue-600 text-white', licznik: 'bg-white/25', ramka: 'ring-blue-400', inicjaly: 'bg-blue-100 text-blue-800', nazwa: 'niebieski' },
  indigo: { kropka: 'bg-indigo-500', tlo: 'bg-indigo-50', naglowek: 'bg-indigo-600 text-white', licznik: 'bg-white/25', ramka: 'ring-indigo-400', inicjaly: 'bg-indigo-100 text-indigo-800', nazwa: 'indygo' },
  violet: { kropka: 'bg-violet-500', tlo: 'bg-violet-50', naglowek: 'bg-violet-600 text-white', licznik: 'bg-white/25', ramka: 'ring-violet-400', inicjaly: 'bg-violet-100 text-violet-800', nazwa: 'fioletowy' },
  pink: { kropka: 'bg-pink-500', tlo: 'bg-pink-50', naglowek: 'bg-pink-600 text-white', licznik: 'bg-white/25', ramka: 'ring-pink-400', inicjaly: 'bg-pink-100 text-pink-800', nazwa: 'różowy' },
  red: { kropka: 'bg-red-500', tlo: 'bg-red-50', naglowek: 'bg-red-600 text-white', licznik: 'bg-white/25', ramka: 'ring-red-400', inicjaly: 'bg-red-100 text-red-800', nazwa: 'czerwony' },
  orange: { kropka: 'bg-orange-500', tlo: 'bg-orange-50', naglowek: 'bg-orange-600 text-white', licznik: 'bg-white/25', ramka: 'ring-orange-400', inicjaly: 'bg-orange-100 text-orange-800', nazwa: 'pomarańczowy' },
  amber: { kropka: 'bg-amber-500', tlo: 'bg-amber-50', naglowek: 'bg-amber-400 text-amber-950', licznik: 'bg-black/10', ramka: 'ring-amber-400', inicjaly: 'bg-amber-100 text-amber-800', nazwa: 'bursztynowy' },
  yellow: { kropka: 'bg-yellow-400', tlo: 'bg-yellow-50', naglowek: 'bg-yellow-300 text-yellow-950', licznik: 'bg-black/10', ramka: 'ring-yellow-400', inicjaly: 'bg-yellow-100 text-yellow-800', nazwa: 'żółty' },
  lime: { kropka: 'bg-lime-500', tlo: 'bg-lime-50', naglowek: 'bg-lime-400 text-lime-950', licznik: 'bg-black/10', ramka: 'ring-lime-400', inicjaly: 'bg-lime-100 text-lime-800', nazwa: 'limonkowy' },
  green: { kropka: 'bg-green-600', tlo: 'bg-green-50', naglowek: 'bg-green-600 text-white', licznik: 'bg-white/25', ramka: 'ring-green-400', inicjaly: 'bg-green-100 text-green-800', nazwa: 'zielony' },
  emerald: { kropka: 'bg-emerald-500', tlo: 'bg-emerald-50', naglowek: 'bg-emerald-600 text-white', licznik: 'bg-white/25', ramka: 'ring-emerald-400', inicjaly: 'bg-emerald-100 text-emerald-800', nazwa: 'szmaragdowy' },
  teal: { kropka: 'bg-teal-500', tlo: 'bg-teal-50', naglowek: 'bg-teal-600 text-white', licznik: 'bg-white/25', ramka: 'ring-teal-400', inicjaly: 'bg-teal-100 text-teal-800', nazwa: 'morski' },
}

export const kolorEtapu = (kolor) => PALETA[kolor] || PALETA.gray
export const kolorKropki = (kolor) => kolorEtapu(kolor).kropka

export const KROKI = {
  spotkanie: {
    etykieta: 'Spotkanie: dobór zestawu',
    tytul: 'Przygotuj spotkanie',
    tekst: 'Dobierz zestaw pod moc i budżet klienta i weź go na spotkanie. Z asystenta zestaw sam trafi do karty klienta.',
    akcje: ['dobierz'],
  },
  oferta: {
    etykieta: 'Oferta: czekanie na decyzję',
    tytul: 'Czekasz na decyzję klienta',
    tekst: 'Przygotuj ofertę w karcie i wyślij ją klientowi. Zapisz w notatce, kiedy się odezwać, a gdy klient podpisze umowę, zaznacz to niżej.',
    akcje: ['notatka'],
  },
  podpisany: {
    etykieta: 'Podpisany: zamówienie sprzętu',
    tytul: 'Zamów sprzęt',
    tekst: 'Klient podpisał umowę. Sprawdź aktualne ceny i dostępność sprzętu, złóż zamówienia i zaznacz je niżej.',
    akcje: ['ceny'],
  },
  zamawianie: {
    etykieta: 'Zamawianie: pilnowanie zamówień',
    tytul: 'Pilnuj zamówień',
    tekst: 'Zaznacz każdą zamówioną pozycję i ustal termin dostawy.',
    akcje: ['ceny'],
  },
  dostawa: {
    etykieta: 'Dostawa: odbiór i termin montażu',
    tytul: 'Odbierz dostawę i umów montaż',
    tekst: 'Porównaj dostawę z listą sprzętu, zaznacz, co dojechało, i ustal z klientem termin montażu.',
    akcje: ['lista', 'notatka'],
  },
  montaz: {
    etykieta: 'Montaż: numery seryjne',
    // Runda 4 (2026-10-11): montaż w dwóch krokach, rozpoczęcie i zakończenie potwierdza się w „Terminach”.
    tytul: 'Zakończ montaż i zbierz wszystkie informacje',
    tekst: 'Zaznacz w terminach rozpoczęcie i zakończenie montażu. Spisz numery seryjne i zrób zdjęcia tabliczek znamionowych: przydadzą się w zgłoszeniu do operatora i w teczce PME2.',
    akcje: ['teczka'],
  },
  // 2026-10-11: bez warunków, od razu proponuje „Formalności” (tam zgłoszenie do operatora, PSP i PME2).
  po_montazu: {
    etykieta: 'Po montażu: przejście do formalności',
    tytul: 'Montaż zakończony',
    tekst: 'Instalacja stoi. Dalej formalności: zgłoszenie do operatora, zawiadomienie do PSP i wniosek PME2.',
    akcje: [],
  },
  formalnosci: {
    etykieta: 'Formalności: operator, PSP i PME2',
    tytul: 'Załatw formalności',
    tekst: 'Każde w swoim terminie i w dowolnej kolejności. Zaznacz, gdy wyślesz.',
    akcje: [],
  },
  // Dwa kroki niżej zostają dla firm z własnymi etapami sprzed „Formalności” (2026-10-11).
  zgloszenie_osd: {
    etykieta: 'Zgłoszenie OSD: wniosek PME2',
    tytul: 'Dotacja na magazyn energii',
    tekst: 'Gdy operator potwierdzi zgłoszenie magazynu, klient może złożyć wniosek PME2 (nabór od 20.10.2026).',
    akcje: ['teczka'],
  },
  dotacja: {
    etykieta: 'Dotacja: poprawki wniosku',
    tytul: 'Pilnuj poczty od NFOŚiGW',
    tekst: 'Na uzupełnienie braków we wniosku jest 10 dni roboczych od wezwania. Sprawdzajcie z klientem skrzynkę, także spam.',
    akcje: ['teczka'],
  },
}

/** Etap po id albo zastępczy „Bez etapu” (etap usunięty w ustawieniach albo pusty). */
export const BEZ_ETAPU = { id: '', nazwa: 'Bez etapu', kolor: 'gray', krok: '' }
export const znajdzEtap = (etapy, id) => (etapy || []).find((e) => e.id === id) || BEZ_ETAPU

/** Liczba z pola („7,35”) albo null; do mocy i pojemności. */
export const liczbaZPola = (v) => {
  const x = Number(String(v ?? '').replace(',', '.').replace(/\s/g, ''))
  return Number.isFinite(x) && x > 0 ? x : null
}

/** „7,35 kWp”, „14,3 kWh”; pusty łańcuch bez wartości. */
export const zJednostka = (x, jednostka) => (x == null ? '' : `${String(Math.round(x * 100) / 100).replace('.', ',')} ${jednostka}`)

const ZRODLA = { karta: '', teczka: 'z teczki PME2', zestaw: 'z zestawu' }
export const opisZrodla = (zrodlo) => ZRODLA[zrodlo] || ''
